/* Forstwald, theme.js (Kern, defer, unter 11 KB). API: window.Forstwald, siehe README-theme.md.
   Bus-Ereignisse gehen zusätzlich als DOM-Event mit Präfix forstwald: raus. */
(() => {
  'use strict';
  const d = document;
  const root = d.documentElement;
  const FW = (window.Forstwald = window.Forstwald || {});
  const bus = {};

  FW.on = (e, f) => {
    (bus[e] = bus[e] || new Set()).add(f);
    return () => FW.off(e, f);
  };
  FW.off = (e, f) => bus[e] && bus[e].delete(f);
  FW.once = (e, f) => {
    const off = FW.on(e, (x) => {
      off();
      f(x);
    });
    return off;
  };
  FW.emit = (e, detail = {}) => {
    (bus[e] || []).forEach((f) => {
      try {
        f(detail);
      } catch (err) {
        console.error(err);
      }
    });
    d.dispatchEvent(new CustomEvent('forstwald:' + e, { detail }));
  };

  const SH = window.Shopify || {};
  FW.routes = FW.routes || {};
  FW.root = FW.routes.root || (SH.routes && SH.routes.root) || '/';
  FW.reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  FW.debounce = (f, ms = 250) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => f(...a), ms);
    };
  };
  FW.money = (cents) =>
    new Intl.NumberFormat(root.lang || 'de', {
      style: 'currency',
      currency: FW.currency || (SH.currency && SH.currency.active) || 'EUR',
      minimumFractionDigits: cents % 100 ? 2 : 0,
    }).format(cents / 100);

  FW.fetchJSON = async (url, opts = {}) => {
    let res;
    try {
      res = await fetch(url, { ...opts, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...(opts.headers || {}) } });
    } catch (e) {
      const err = new Error('network');
      err.network = true;
      throw err;
    }
    let data = null;
    try {
      data = await res.json();
    } catch (e) {}
    if (!res.ok) {
      const err = new Error((data && (data.description || data.message)) || res.statusText);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  };

  FW.announce = (msg) => {
    const el = d.getElementById('fw-live');
    if (!el) return;
    el.textContent = '';
    requestAnimationFrame(() => (el.textContent = msg));
  };

  FW.whenVisible = (el, cb, margin = '200px') => {
    if (!('IntersectionObserver' in window)) return cb();
    const io = new IntersectionObserver(
      (en) => {
        if (en.some((x) => x.isIntersecting)) {
          io.disconnect();
          cb();
        }
      },
      { rootMargin: margin }
    );
    io.observe(el);
  };
  const scripts = {};
  FW.loadScript = (src) =>
    (scripts[src] =
      scripts[src] ||
      new Promise((ok, no) => {
        const s = d.createElement('script');
        s.src = src;
        s.defer = true;
        s.onload = ok;
        s.onerror = no;
        d.head.appendChild(s);
      }));
  d.querySelectorAll('[data-lazy-script]').forEach((el) => FW.whenVisible(el, () => FW.loadScript(el.dataset.lazyScript)));

  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  FW.focusables = (el) => [...el.querySelectorAll(FOCUSABLE)].filter((n) => n.getClientRects().length);
  FW.trapFocus = (el) => {
    const h = (e) => {
      if (e.key !== 'Tab') return;
      const f = FW.focusables(el);
      if (!f.length) return e.preventDefault();
      const a = f[0];
      const z = f[f.length - 1];
      if (e.shiftKey && d.activeElement === a) {
        e.preventDefault();
        z.focus();
      } else if (!e.shiftKey && d.activeElement === z) {
        e.preventDefault();
        a.focus();
      }
    };
    el.addEventListener('keydown', h);
    return () => el.removeEventListener('keydown', h);
  };

  let locks = 0;
  const lock = (on) => {
    locks = Math.max(0, locks + (on ? 1 : -1));
    root.classList.toggle('is-locked', locks > 0);
  };
  const dlgOf = (t) => (typeof t === 'string' ? d.getElementById(t) : t);
  FW.openDialog = (target, trigger) => {
    const dlg = dlgOf(target);
    if (!dlg || dlg.open || typeof dlg.showModal !== 'function') return dlg;
    dlg._trigger = trigger || d.activeElement;
    dlg.classList.remove('is-closing');
    dlg.showModal();
    dlg._locked = true;
    lock(true);
    const f = dlg.querySelector('[data-dialog-focus]');
    if (f) f.focus({ preventScroll: true });
    FW.emit('dialog:open', { dialog: dlg, id: dlg.id });
    return dlg;
  };
  FW.closeDialog = (target) => {
    const dlg = dlgOf(target);
    if (!dlg || !dlg.open || dlg._closing) return;
    const done = () => {
      dlg._closing = false;
      dlg.classList.remove('is-closing');
      dlg.close();
    };
    if (FW.reduceMotion()) return done();
    dlg._closing = true;
    dlg.classList.add('is-closing');
    setTimeout(done, 200);
  };
  d.addEventListener(
    'close',
    (e) => {
      const dlg = e.target;
      if (!(dlg instanceof HTMLDialogElement)) return;
      if (dlg._locked) {
        dlg._locked = false;
        lock(false);
      }
      const t = dlg._trigger;
      dlg._trigger = null;
      if (t && t.isConnected && typeof t.focus === 'function') t.focus({ preventScroll: true });
      FW.emit('dialog:close', { dialog: dlg, id: dlg.id });
    },
    true
  );
  d.addEventListener(
    'cancel',
    (e) => {
      if (e.target instanceof HTMLDialogElement) {
        e.preventDefault();
        FW.closeDialog(e.target);
      }
    },
    true
  );

  d.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const open = t.closest('[data-drawer-open]');
    if (open) {
      e.preventDefault();
      FW.openDialog(open.dataset.drawerOpen, open);
      return;
    }
    const close = t.closest('[data-drawer-close]');
    if (close && close.closest('dialog')) {
      e.preventDefault();
      FW.closeDialog(close.closest('dialog'));
      return;
    }
    if (t instanceof HTMLDialogElement && t.open && t.dataset.backdrop !== 'off') FW.closeDialog(t);

    if (t.closest('[data-cookie-preferences]')) {
      e.preventDefault();
      const S = window.Shopify || {};
      const api = window.privacyBanner || S.privacyBanner || S.customerPrivacy;
      /* Ohne aktives Cookie-Banner in Shopify gibt es nichts zu öffnen: dann kommt ein kurzer Hinweis statt Stille. */
      const none = () => {
        const n = d.querySelector('[data-cookie-note]');
        if (!n) return;
        n.hidden = false;
        FW.announce(n.textContent.trim());
      };
      if (api && api.showPreferences) api.showPreferences();
      else if (S.loadFeatures) {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          const c = window.Shopify.customerPrivacy;
          if (c && c.showPreferences) c.showPreferences();
          else none();
        });
      } else none();
    }

    const sum = t.closest('summary');
    const det = sum && sum.parentElement;
    if (det && det.matches('details.accordion')) {
      const body = det.querySelector('.accordion__content');
      const group = det.dataset.group;
      if (group && !det.open) d.querySelectorAll('details.accordion[data-group="' + group + '"][open]').forEach((o) => o !== det && (o.open = false));
      if (!body || FW.reduceMotion() || !body.animate) return;
      e.preventDefault();
      if (det._anim) det._anim.cancel();
      const was = det.open;
      if (!was) det.open = true;
      const h = body.scrollHeight + 'px';
      det._anim = body.animate({ height: was ? [h, '0px'] : ['0px', h] }, { duration: 150, easing: 'ease-out' });
      det._anim.onfinish = det._anim.oncancel = () => {
        det._anim = null;
        if (was) det.open = false;
      };
    }
    if (det && det.hasAttribute('data-desktop-open') && wide.matches) e.preventDefault();
  });

  /* Länder- und Sprachwahl: Auswahl sendet das Formular sofort ab */
  d.addEventListener('change', (e) => {
    const f = e.target instanceof Element && e.target.closest('form[data-localization]');
    if (f && e.target.matches('select')) f.submit();
  });

  class FwQuantity extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-qty]');
        if (!b) return;
        e.preventDefault();
        this.set((parseInt(this.input.value, 10) || 0) + parseInt(b.dataset.qty, 10), true);
      });
      this.input.addEventListener('change', () => this.set(parseInt(this.input.value, 10)));
      this.sync();
    }
    set(v, notify) {
      const i = this.input;
      const min = i.min === '' ? 1 : +i.min;
      const max = i.max === '' ? Infinity : +i.max;
      v = Math.min(max, Math.max(min, Number.isNaN(v) ? min : v));
      const changed = String(v) !== i.value;
      i.value = v;
      this.sync();
      if (changed || notify) i.dispatchEvent(new Event('change', { bubbles: true }));
    }
    sync() {
      const v = +this.input.value;
      const minus = this.querySelector('[data-qty^="-"]');
      const plus = this.querySelector('[data-qty="1"]');
      if (minus) minus.disabled = this.input.min !== '' && +this.input.min >= 1 && v <= +this.input.min;
      if (plus) plus.disabled = this.input.max !== '' && v >= +this.input.max;
    }
  }
  if (!customElements.get('fw-quantity')) customElements.define('fw-quantity', FwQuantity);

  const wide = matchMedia('(min-width: 900px)');
  const syncDetails = () =>
    d.querySelectorAll('details[data-desktop-open]').forEach((el) => {
      const sum = el.querySelector(':scope > summary');
      if (wide.matches) el.open = true;
      else if (!el.hasAttribute('data-keep-open')) el.open = false;
      if (sum) sum.tabIndex = wide.matches ? -1 : 0;
    });
  wide.addEventListener('change', syncDetails);
  syncDetails();

  /* Nach dem Absenden lädt die Seite neu: Die Erfolgsmeldung in den Blick holen und fokussieren (Screenreader lesen sie dann vor). */
  const sent = d.querySelector('.form-message--success[tabindex="-1"]:not([hidden]):not([data-notify-success])');
  if (sent) {
    sent.scrollIntoView({ block: 'center' });
    sent.focus({ preventScroll: true });
  }

  FW.emit('ready');
})();
